"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _control = _interopRequireDefault(require("@/components/customPage/control.vue"));
var _colour = _interopRequireDefault(require("@/components/customPage/colour.vue"));
var _slider = _interopRequireDefault(require("@/components/customPage/slider.vue"));
var _choose = _interopRequireDefault(require("@/components/customPage/choose.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  components: {
    control: _control.default,
    colour: _colour.default,
    slider: _slider.default,
    choose: _choose.default
  },
  props: {
    cData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      contentdef: {},
      chamferData: [{
        value: 1,
        icon: 'le-icon-graphic-party',
        name: '方角'
      }, {
        value: 2,
        icon: 'le-icon-graphic-rounded',
        name: '圆角'
      }],
      pointerData: [{
        value: 1,
        src: 'https://artimg2.artart.cn/image/20211216/781dfcbdbcf140f259da4123e9e6cb0a.png',
        active: true
      }, {
        value: 2,
        src: 'https://artimg2.artart.cn/image/20211216/1c2ed5ab73097335242865c47b57f66d.png',
        active: true
      }, {
        value: 3,
        src: 'https://artimg2.artart.cn/image/20211216/6f0c2ed4792dd368f73b722480cc551c.png',
        active: true
      }],
      positionData: [{
        value: 'left',
        icon: 'le-icon-graphic-left',
        name: '居左'
      }, {
        value: 'center',
        icon: 'le-icon-graphic-middle',
        name: '居中'
      }, {
        value: 'right',
        icon: 'le-icon-graphic-right',
        name: '居右'
      }],
      styleData: [{
        value: 1,
        src: 'https://artimg2.artart.cn/image/20211014/448ab7f5d7b642003cdc7833eaeb6e48.png',
        name: '左右滑动'
      }, {
        value: 2,
        src: 'https://artimg2.artart.cn/image/20211014/a2e8c8a6bbf499fa83ee1721dbb4efc9.png',
        name: '上下排列'
      }]
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {
    content: {
      get: function get() {
        return this.$store.getters.content;
      },
      set: function set(value) {
        var data = {
          key: 'content',
          value: value
        };
        this.$store.commit('finish/setAttribute', data);
      }
    },
    facade: {
      get: function get() {
        return this.$store.state.finish.pageInfo;
      },
      set: function set(value) {
        this.$store.commit('finish/setPageInfo', value);
      }
    }
  },
  /**
   * 页面渲染前
   * @return {[type]} [description]
   */
  created: function created() {},
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    is_active: function is_active(item) {
      if (item.value === this.content.style) {
        return true;
      }
      return false;
    },
    delImg: function delImg(index) {
      this.content.data[index].url = '';
    },
    /**
     * 删除元素
     * @return {[type]} [description]
     */
    handleDelete: function handleDelete(index) {
      this.content.data.splice(index, 1);
    },
    /**
     * 添加元素
     * @return {[type]} [description]
     */
    handleAdditem: function handleAdditem() {
      this.$refs.selectView.changeshow();
    },
    goUp: function goUp(index) {
      if (index === 0) {
        return;
      }
      this.content.data.splice(index - 1, 0, this.content.data[index]);
      this.content.data.splice(index + 1, 1);
    },
    goDown: function goDown(index) {
      if (index === this.content.data - 1) {
        return;
      }
      this.content.data.splice(index + 2, 0, this.content.data[index]);
      this.content.data.splice(index, 1);
    },
    uploadIconAction: function uploadIconAction(res, file, index) {
      if (res && res.url) {
        var newFile = file;
        newFile.url = res.url;
        this.content.data[index].url = res.url;
      }
    },
    selectMessage: function selectMessage(data) {
      this.content.data = data.data;
    }
  }
};
exports.default = _default2;